import React from 'react';
import PropTypes from 'prop-types';
import Tabs, { Tab } from 'packages/ui/NavigationTabs';

function SettingsTabs({ activeKey, eventId, eventSlug }) {
  return (
    <Tabs>
      <Tab active={activeKey === 'statistics'} to={`/events/${eventId}/${eventSlug}/edit`}>
        تنظیمات
      </Tab>
      <Tab
        active={activeKey === 'notifications'}
        to={`/events/${eventId}/${eventSlug}/notifications`}
      >
        یادآوری
      </Tab>
    </Tabs>
  );
}

SettingsTabs.propTypes = {
  activeKey: PropTypes.oneOf(['edit', 'notifications']),
  eventId: PropTypes.number.isRequired
};

export default SettingsTabs;
